import { useEffect } from 'react'

/** Match backend pg_cron interval for symbol live prices. */
export const MARKET_DATA_REFRESH_MS = 5 * 60 * 1000

export function useMarketDataRefreshInterval(
  refetch: () => void,
  enabled: boolean,
  intervalMs: number = MARKET_DATA_REFRESH_MS
) {
  useEffect(() => {
    if (!enabled) return
    const id = window.setInterval(refetch, intervalMs)
    return () => window.clearInterval(id)
  }, [refetch, enabled, intervalMs])
}
